import { convertDate, sortHashtags } from "helpers";
import { useClickAndView } from "hooks";
import { useInView } from "react-intersection-observer";
import { Magazine } from "types";
import Badge from "./Badge";

type Props = {
  post: Magazine.PostItem;
};

export default function PostCard({ post }: Props) {
  const [clickAndView] = useClickAndView({
    contentId: post.id,
    variant: "post",
    click: false,
  });

  const [ref] = useInView({
    delay: 2500,
    onChange: (inView) => {
      if (inView) clickAndView();
    },
    threshold: 1,
    triggerOnce: true,
  });

  return (
    <article ref={ref} className="w-full py-1 px-5">
      <div className="py-1 space-y-1">
        <h3 className="text-sm font-medium text-dark">{post.title}</h3>
        <h3 className="text-sm font-medium text-[#5E6278] empty:hidden">
          {post.postType?.title?.at(0)?.value}
        </h3>
      </div>
      <p className="text-sm text-[#5E6278] font-normal py-1">
        {post.description}
      </p>
      <div className="flex flex-wrap gap-1 py-1 empty:hidden">
        {sortHashtags(post.hashtag)?.map((e) => (
          <Badge key={e}>#{e}</Badge>
        ))}
      </div>
      <p className="text-xs font-medium text-[#9A9EB1] py-1">
        {convertDate(post.creationTime, "full-date")}
      </p>
      <div className="w-full h-2.5 flex items-center">
        <hr className="border-[#ECEFF2] w-full" />
      </div>
    </article>
  );
}
